export function normaliseUmlautsAndEszett(s: string) {
    const replacementMap = {
        'ä': 'ae',
        'ö': 'oe',
        'ü': 'ue',
        'Ä': 'Ae',
        'Ö': 'Oe',
        'Ü': 'Ue',
        'ß': 'ss',
    }
    return s.replace(/[äöüÄÖÜß]/g, match => replacementMap[match as keyof typeof replacementMap])
}